import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { CoreModule } from '@app/core';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LoadingComponent } from '@app/core/components';

import { LoadingService } from '@app/core/services';

@NgModule({
    imports: [
        BrowserModule,
        CoreModule,
        AppRoutingModule
    ],
    declarations: [AppComponent, LoadingComponent],
    bootstrap: [AppComponent],
    providers: [LoadingService]
})
export class AppModule
{
}
